import { render, staticRenderFns } from "./RolesAdminPage.vue?vue&type=template&id=de3ca234"
import script from "./RolesAdminPage.vue?vue&type=script&lang=js"
export * from "./RolesAdminPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports